module.exports = __webpack_public_path__ + "static/media/legolas.db0d9a35.png";